module.exports = __webpack_public_path__ + "img/2d_map_single.71ea9bf4.gif";